import TrackIcon from "@/assets/icons/track-outline.svg?react";
import { TrackingDetailElem } from "./trackingDetailElem";
import { FedexScanEvent } from "@/types/fedex.type";

type TrackingDetailProps = {
  scanEvents: FedexScanEvent[];
  locale: string;
};

export const TrackingDetail = ({ scanEvents, locale }: TrackingDetailProps) => {
  return (
    <div className="flex w-full flex-col gap-5 rounded-xl border border-gray-200 bg-white p-6 shadow-xs lg:w-2/3">
      <div className="flex w-full flex-row items-center gap-4">
        <TrackIcon width={24} height={24} />
        <span className="text-sm font-semibold text-black">
          {locale === "fr" ? "Historique de voyage" : "Tracking history"}
        </span>
      </div>
      <div className="flex w-full flex-col gap-4">
        {scanEvents
          .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
          .map((scanEvent, index) => (
            <TrackingDetailElem
              key={`${scanEvent.date}-${index}`}
              index={index}
              scanEvent={scanEvent}
              scanEventsLength={scanEvents.length}
              locale={locale}
            />
          ))}
      </div>
    </div>
  );
};
